/* Dynamic cart upsell: shows a product the visitor viewed this session
   (excluding anything already in cart); falls back to the newest arrival
   if there is no eligible viewed product. Falls back to the merchant's
   static section-configured product (already server-rendered) if anything
   here fails or returns nothing.

   Campaign recommendations take priority: when the cart holds a trigger
   variant (e.g. a 《喝采》 cover), the matching related variants are offered
   at their regular price. */
(function () {
  'use strict';

  var STORAGE_KEY = 'dcv_session_viewed_products';
  var NEWEST_COLLECTION_HANDLE = 'internal-all-products-newest';

  var LABELS = {
    'zh-TW': { buy: '立即購買', view: '查看產品', addon: '加入購物車', relatedHeading: '《喝采》封面明星精品推介' },
    'ja': { buy: '今すぐ購入', view: '製品を表示', addon: 'カートに追加', relatedHeading: '《喝采》表紙スターのおすすめグッズ' },
    'ko': { buy: '지금 구매하기', view: '상품 보기', addon: '장바구니 담기', relatedHeading: '《喝采》 표지 스타 추천 굿즈' }
  };

  /* 《喝采 — 青春全記錄》 cover-matched recommendations, shown at regular price. */
  var STANDEE = 'yuen-tai-yung-standee';
  var STICKERS = 'yuen-tai-yung-stars-sticker-pack';
  var ADDON_PRODUCTS = {};
  ADDON_PRODUCTS[STANDEE] = '2026-cny-yuen-tai-yung-standee';
  ADDON_PRODUCTS[STICKERS] = '2026-cny-yuen-tai-yung-stars-sticker-pack';

  var CAMPAIGN_ADDONS = [
    { // 陳百強封面 → 經典封面立牌 款式 B
      triggers: [41214075273279, 41214075306047],
      addons: [{ product: STANDEE, variantId: 42839839572031 }]
    },
    { // 張國榮封面 → 經典封面立牌 款式 A + 明星插畫貼紙包 男星套裝
      triggers: [41214075338815, 41214075371583],
      addons: [
        { product: STANDEE, variantId: 42839841898559 },
        { product: STICKERS, variantId: 42829992198207 }
      ]
    },
    { // 翁靜晶封面 → 明星插畫貼紙包 女星套裝
      triggers: [41214075404351, 41214075437119],
      addons: [{ product: STICKERS, variantId: 42829992230975 }]
    }
  ];

  function localePrefix() {
    var m = window.location.pathname.match(/^\/(ja-jp|ko-kr)(\/|$)/);
    return m ? '/' + m[1] : '';
  }

  function labelSet() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang.indexOf('ja') === 0) return LABELS.ja;
    if (lang.indexOf('ko') === 0) return LABELS.ko;
    return LABELS['zh-TW'];
  }

  function moneyFormat() {
    return (window.KROWN && window.KROWN.settings && window.KROWN.settings.shop_money_format) || '${{amount}}';
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (!format) return '$' + value;
    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }
    return format.replace('{{amount}}', value);
  }

  function withWidth(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  async function safeFetchJson(url) {
    try {
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  /* Product JSON is cached for the page's lifetime so the drawer can swap in
     an add-on without a network round trip after the cart changes. */
  var productCache = {};

  function fetchProduct(prefix, handle) {
    if (!handle) return Promise.resolve(null);
    var url = prefix + '/products/' + handle + '.js';
    if (!productCache[url]) {
      productCache[url] = safeFetchJson(url).then(function (product) {
        if (!product) delete productCache[url];
        return product;
      });
    }
    return productCache[url];
  }

  function prefetchCampaignProducts() {
    var prefix = localePrefix();
    Object.keys(ADDON_PRODUCTS).forEach(function (key) {
      fetchProduct(prefix, ADDON_PRODUCTS[key]);
    });
  }

  function getSessionViewed(cartProductIds) {
    var list = [];
    try { list = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { list = []; }
    return list
      .filter(function (p) { return p && p.handle && !cartProductIds.has(p.id); })
      .sort(function (a, b) { return (b.ts || 0) - (a.ts || 0); });
  }

  async function pickCandidateProduct(prefix, cartProductIds) {
    var viewed = getSessionViewed(cartProductIds);
    for (var i = 0; i < viewed.length; i++) {
      var p = await fetchProduct(prefix, viewed[i].handle);
      if (p && p.available && !cartProductIds.has(p.id)) return p;
    }

    var newest = await safeFetchJson(prefix + '/collections/' + NEWEST_COLLECTION_HANDLE + '/products.json?limit=10');
    if (newest && newest.products) {
      for (var j = 0; j < newest.products.length; j++) {
        var item = newest.products[j];
        if (cartProductIds.has(item.id)) continue;
        var full = await fetchProduct(prefix, item.handle);
        if (full && full.available) return full;
      }
    }

    return null;
  }

  /* Returns the related variants for the trigger items in the cart,
     skipping any already in the cart. */
  async function pickCampaignOffers(prefix, cart) {
    var qtyByVariant = {};
    cart.items.forEach(function (item) {
      qtyByVariant[item.variant_id] = (qtyByVariant[item.variant_id] || 0) + item.quantity;
    });

    var wanted = [];
    CAMPAIGN_ADDONS.forEach(function (rule) {
      var triggered = rule.triggers.some(function (id) { return qtyByVariant[id]; });
      if (!triggered) return;
      rule.addons.forEach(function (addon) {
        if (!qtyByVariant[addon.variantId] && wanted.indexOf(addon) === -1) wanted.push(addon);
      });
    });
    if (!wanted.length) return [];

    var products = {};
    var offers = [];
    for (var i = 0; i < wanted.length; i++) {
      var addon = wanted[i];
      if (!(addon.product in products)) {
        products[addon.product] = await fetchProduct(prefix, ADDON_PRODUCTS[addon.product]);
      }
      var product = products[addon.product];
      if (!product) continue;
      var variant = product.variants.filter(function (v) { return v.id === addon.variantId; })[0];
      if (!variant || !variant.available) continue;
      offers.push({ product: product, variant: variant });
    }
    return offers;
  }

  function addToCartForm(prefix, variantId, label) {
    return (
      '<quick-add-to-cart class="quick-add-to-cart">' +
        '<product-form data-ajax-cart>' +
          '<div class="quick-add-to-cart-button">' +
            '<form method="post" action="' + prefix + '/cart/add" enctype="multipart/form-data">' +
              '<input type="hidden" name="id" value="' + variantId + '">' +
              '<button class="add-to-cart button button--small button--outline--hover-accent button--loader" type="submit" name="add" data-js-product-add-to-cart data-cart-upsell-add>' +
                '<span class="button__text">' + label + '</span>' +
                '<span class="button__loader"></span>' +
              '</button>' +
            '</form>' +
          '</div>' +
        '</product-form>' +
      '</quick-add-to-cart>'
    );
  }

  function itemMarkup(href, imgSrc, title, priceHtml, compareHtml, actionHtml) {
    return (
      '<div class="cart-item cart-individual-product-recommendation" data-js-product-item>' +
        '<a href="' + href + '" class="cart-item__thumbnail">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(title) + '" loading="lazy" width="140" height="140" style="object-fit:cover">' : '') +
        '</a>' +
        '<div class="cart-item__content sidebar__inner-element">' +
          '<div>' +
            '<a href="' + href + '" class="cart-item__title text-size--16">' +
              '<span class="text-animation--underline"><span>' + escapeHtml(title) + '</span></span>' +
            '</a>' +
            '<div class="cart-item__price text-size--16">' +
              '<div class="product-price">' +
                '<span class="product-price--original pps" data-js-product-price-original>' + priceHtml + '</span>' +
                '<del class="product-price--compare" data-js-product-price-compare>' + compareHtml + '</del>' +
              '</div>' +
            '</div>' +
            actionHtml +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function buildMarkup(product, prefix) {
    var labels = labelSet();
    var href = product.url; // /products/*.js already returns a locale-prefixed url
    var format = moneyFormat();
    var priceHtml = formatMoney(product.price, format);
    var compareHtml = '';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      compareHtml = formatMoney(product.compare_at_price, format);
    }

    var actionHtml;
    if (!product.available) {
      actionHtml = '';
    } else if (product.variants.length === 1) {
      actionHtml = addToCartForm(prefix, product.variants[0].id, labels.buy);
    } else {
      actionHtml =
        '<a class="button button--small button--outline--hover-accent" href="' + href + '">' +
          '<span class="button__text">' + labels.view + '</span>' +
        '</a>';
    }

    return itemMarkup(href, withWidth(product.featured_image, 280), product.title, priceHtml, compareHtml, actionHtml);
  }

  function buildOfferMarkup(offer, prefix) {
    var labels = labelSet();
    var variant = offer.variant;
    var href = offer.product.url + '?variant=' + variant.id;
    var image = (variant.featured_image && variant.featured_image.src) || offer.product.featured_image;
    var title = offer.product.title + ' - ' + variant.title;
    var compareHtml = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareHtml = formatMoney(variant.compare_at_price, moneyFormat());
    }
    return itemMarkup(href, withWidth(image, 280), title, formatMoney(variant.price, moneyFormat()), compareHtml, addToCartForm(prefix, variant.id, labels.addon));
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function attachScrollBehaviour() {
    document.querySelectorAll('#cart-upsell-product-slot [data-cart-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (document.getElementById('site-cart-sidebar')) {
          setTimeout(function () {
            var container = document.querySelector('#site-cart-sidebar .sidebar__container');
            if (container) container.scrollTo({ top: 0, behavior: 'smooth' });
          }, 150);
        }
      });
    });
  }

  var running = false;
  var pendingRerun = false;
  var defaultHeading = null;
  var revealTimer = null;

  /* While the cart is changing, hide the current recommendation so the
     drawer never opens showing a stale product (e.g. the item just added). */
  function hideSlot() {
    var block = document.getElementById('cart-upsell-block');
    if (!block) return;
    block.style.visibility = 'hidden';
    clearTimeout(revealTimer);
    revealTimer = setTimeout(revealSlot, 4000);
  }

  function revealSlot() {
    clearTimeout(revealTimer);
    var block = document.getElementById('cart-upsell-block');
    if (block) block.style.visibility = '';
  }

  /* React to the cart request itself instead of waiting for the drawer to
     re-render, which saves roughly a second before the add-on shows up. */
  function watchCartRequests() {
    if (!window.fetch) return;
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      var request = originalFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        hideSlot();
        request.then(refreshUpsell, refreshUpsell);
      }
      return request;
    };
  }

  function setHeading(text) {
    var heading = document.getElementById('cart-upsell-heading');
    if (!heading) return;
    if (defaultHeading === null) defaultHeading = heading.textContent;
    heading.textContent = text == null ? defaultHeading : text;
  }

  async function refreshUpsell() {
    if (running) { pendingRerun = true; return; }
    running = true;
    try {
      var slot = document.getElementById('cart-upsell-product-slot');
      if (!slot) return;

      var prefix = localePrefix();
      var cart = (await safeFetchJson(prefix + '/cart.js')) || { items: [] };
      var cartProductIds = new Set(cart.items.map(function (item) { return item.product_id; }));

      var offers = await pickCampaignOffers(prefix, cart);
      if (offers.length) {
        setHeading(labelSet().relatedHeading);
        slot.innerHTML = offers.map(function (offer) { return buildOfferMarkup(offer, prefix); }).join('');
        attachScrollBehaviour();
        return;
      }

      var product = await pickCandidateProduct(prefix, cartProductIds);
      if (!product) return; // keep the merchant-configured static fallback already rendered

      setHeading(null);
      slot.innerHTML = buildMarkup(product, prefix);
      attachScrollBehaviour();
    } catch (e) {
      /* leave static fallback in place */
    } finally {
      running = false;
      if (pendingRerun) {
        pendingRerun = false;
        refreshUpsell();
      } else {
        revealSlot();
      }
    }
  }

  function init() {
    var block = document.getElementById('cart-upsell-block');
    if (!block) return;

    prefetchCampaignProducts();
    watchCartRequests();
    refreshUpsell();

    var cartForm = document.getElementById('AjaxCartForm');
    if (cartForm) {
      var debounceTimer = null;
      new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(refreshUpsell, 400);
      }).observe(cartForm, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
